// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WrVU","content":"styles_content__ZeZ3s","tableWrap":"styles_tableWrap__2uusq"};